import { render, staticRenderFns } from "./GithubPizzaStore.vue?vue&type=template&id=5b5db05a&"
import script from "./GithubPizzaStore.vue?vue&type=script&lang=js&"
export * from "./GithubPizzaStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports